/**
 * Redirects the top-level window (or current window if not in an iframe) to the given URL.
 *
 * This is used so that the CDR Ready wizard that embeds the consumer portal as an Iframe can get redirected, 
 * instead of just the contents of the iframe.
 */
export function redirectParentPage(redirectUri?: string) {
  if (!redirectUri) {
    throw new Error("Redirect Url not provided");
  }
  
  const windowNavigator = window.top ?? window;
  windowNavigator.location.href = redirectUri;
  
}